import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import userReducer from './userReducer'
import { apiAdmin } from './apiReducer'

export const store = (preloadedState) => configureStore({
  reducer: {
    user: userReducer,
    [apiAdmin.reducerPath]: apiAdmin.reducer,

  },
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiAdmin.middleware)
})

setupListeners(store().dispatch)